import { initializeApp } from "firebase/app";
import { getAuth } from "firebase/auth";
import { getFirestore } from "firebase/firestore";

const firebaseConfig = {
  apiKey: "AIzaSyAuhiC8RtgsQERv0ZABwqLxcdyQnc7b0bE",
  authDomain: "red-shutter-camera-store.firebaseapp.com",
  projectId: "red-shutter-camera-store",
  storageBucket: "red-shutter-camera-store.firebasestorage.app",
  messagingSenderId: "1059393261087",
  appId: "1:1059393261087:web:de3024921534a8d2bbcf2a",
  measurementId: "G-WK8D7PQC9X",
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const db = getFirestore(app);
